import { Box, Button, Grid, Paper } from "@mui/material";

interface FormBaseProps {
  baseSubmit: () => void;
  isDirty: boolean;
  isValid: boolean;
  children: React.ReactNode;
  hasPermission: boolean;
}

export function ChatOpsFormBase({
  baseSubmit,
  isDirty,
  isValid,
  children,
  hasPermission,
}: FormBaseProps) {
  return (
    <Paper>
      <Box component="form" onSubmit={baseSubmit}>
        <Grid container spacing={5} sx={{ p: 2 }}>
          {children}
          <Grid size={12}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={!isDirty || !isValid || !hasPermission}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
